import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Menu from './quest/Menu'
import Header from './quest/Header'
import Body from './quest/Body'
import AssignmentArea from './quest/AssignmentArea'
import AssignmentModal from './quest/assignment/AssignmentModal'
import UnassignmentModal from './quest/assignment/UnassignmentModal'
import ReviewBanner from './quest/ReviewBanner'

import {
  assignmentClick,
  assignmentCancelClick,
  unassignmentClick,
  unassignmentCancelClick
} from '../actions/assignment'
import {
  isExternalReviewer,
  isQuestCopyEditorOrQuestAuthorOrQuestManager
} from '../utils/user'
import { isNullOrEmpty } from '../utils'
import { questIsInDraftState } from '../utils/review'
import { questIsAssignedToUser } from '../utils/assignment'

export default class Quest extends Component {
  constructor(props) {
    super(props)
    this.openAssignmentModalBound = this.openAssignmentModal.bind(this)
    this.openUnassignmentModalBound = this.openUnassignmentModal.bind(this)
  }

  async componentDidMount() {
    const { dispatch } = this.props
    dispatch(assignmentCancelClick())
    dispatch(unassignmentCancelClick())
  }

  render() {
    const {
      quest,
      dispatch,
      isEditingQuest,
      isAssigning,
      user,
      organization,
      assignableUsers,
      isUnassigning,
      activities
    } = this.props

    const hasAssignments =
      isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization) ||
      !isNullOrEmpty(quest.assigned_to)
        ? 'has-assignments'
        : ''

    return (
      <div className="quest-view">
        <ReviewBanner quest={quest} />
        <div id="questContainer">
          <Header quest={quest} />
          <div id="questBody">
            <Body
              quest={quest}
              handleAssignClick={this.openAssignmentModalBound}
            />

            <div className={`quest-detail-right ${hasAssignments}`}>
              {this.renderAssignmentArea() && (
                <AssignmentArea
                  {...this.props}
                  handleAssignClick={this.openAssignmentModalBound}
                  handleUnassignClick={this.openUnassignmentModalBound}
                  questIsAssignedToUser={questIsAssignedToUser(quest, user)}
                  isQuestCopyEditorOrQuestAuthorOrQuestManager={isQuestCopyEditorOrQuestAuthorOrQuestManager(
                    user,
                    quest,
                    organization
                  )}
                />
              )}
              <Menu
                quest={quest}
                dispatch={dispatch}
                isEditingQuest={isEditingQuest}
                activities={activities}
              />
            </div>
          </div>
        </div>
        {isAssigning && (
          <AssignmentModal
            dispatch={dispatch}
            quest={quest}
            isQuestCopyEditorOrQuestAuthorOrQuestManager={isQuestCopyEditorOrQuestAuthorOrQuestManager(
              user,
              quest,
              organization
            )}
            users={assignableUsers}
            user={user}
          />
        )}
        {isUnassigning && (
          <UnassignmentModal
            quest={quest}
            dispatch={dispatch}
            questIsAssignedToUser={questIsAssignedToUser(quest, user)}
          />
        )}
      </div>
    )
  }

  openAssignmentModal() {
    this.props.dispatch(assignmentClick())
  }

  openUnassignmentModal() {
    this.props.dispatch(unassignmentClick())
  }

  renderAssignmentArea() {
    const { quest, user, organization } = this.props

    return (
      (!isNullOrEmpty(quest.assigned_to) ||
        isQuestCopyEditorOrQuestAuthorOrQuestManager(
          user,
          quest,
          organization
        )) &&
      !isExternalReviewer(user) &&
      questIsInDraftState(quest)
    )
  }
}

Quest.propTypes = {
  quest: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isEditingQuest: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  isAssigning: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  assignableUsers: PropTypes.array.isRequired,
  isUnassigning: PropTypes.bool.isRequired,
  activities: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Quest.js